var map = {
	"./": [
		318,
		9
	],
	"./Results.dictionaty": [
		341,
		3
	],
	"./Results.dictionaty.json": [
		341,
		3
	],
	"./Results.explanation": [
		1143,
		9,
		142
	],
	"./Results.explanation.ts": [
		1143,
		9,
		142
	],
	"./Results.module.scss": [
		1144,
		9,
		271
	],
	"./ResultsPage": [
		1145,
		9,
		8,
		11,
		143
	],
	"./ResultsPage.tsx": [
		1145,
		9,
		8,
		11,
		143
	],
	"./ResultsPageDeferred": [
		365,
		9
	],
	"./ResultsPageDeferred.tsx": [
		365,
		9
	],
	"./actions": [
		342,
		9
	],
	"./actions.ts": [
		342,
		9
	],
	"./components/Filters": [
		1011,
		9,
		8,
		11,
		46
	],
	"./components/Filters/": [
		1011,
		9,
		8,
		11,
		46
	],
	"./components/Filters/ButtonBar": [
		938,
		9,
		47
	],
	"./components/Filters/ButtonBar/": [
		938,
		9,
		47
	],
	"./components/Filters/ButtonBar/ButtonBar.module.scss": [
		1045,
		9,
		278
	],
	"./components/Filters/ButtonBar/index": [
		938,
		9,
		47
	],
	"./components/Filters/ButtonBar/index.tsx": [
		938,
		9,
		47
	],
	"./components/Filters/DatePick": [
		987,
		9,
		8,
		48
	],
	"./components/Filters/DatePick/": [
		987,
		9,
		8,
		48
	],
	"./components/Filters/DatePick/DatePick.module.scss": [
		1068,
		9,
		279
	],
	"./components/Filters/DatePick/index": [
		987,
		9,
		8,
		48
	],
	"./components/Filters/DatePick/index.tsx": [
		987,
		9,
		8,
		48
	],
	"./components/Filters/DatePick/types": [
		1147,
		7,
		170
	],
	"./components/Filters/DatePick/types.ts": [
		1147,
		7,
		170
	],
	"./components/Filters/Filter.module.scss": [
		1146,
		9,
		280
	],
	"./components/Filters/Filters.dictionary": [
		1072,
		3,
		171
	],
	"./components/Filters/Filters.dictionary.json": [
		1072,
		3,
		171
	],
	"./components/Filters/Search": [
		988,
		9,
		49
	],
	"./components/Filters/Search/": [
		988,
		9,
		49
	],
	"./components/Filters/Search/Search.dictionary": [
		1042,
		3,
		172
	],
	"./components/Filters/Search/Search.dictionary.json": [
		1042,
		3,
		172
	],
	"./components/Filters/Search/Search.module.scss": [
		1069,
		9,
		281
	],
	"./components/Filters/Search/index": [
		988,
		9,
		49
	],
	"./components/Filters/Search/index.tsx": [
		988,
		9,
		49
	],
	"./components/Filters/Sorts": [
		989,
		9,
		50
	],
	"./components/Filters/Sorts/": [
		989,
		9,
		50
	],
	"./components/Filters/Sorts/Sorts.dictionary": [
		1043,
		3,
		173
	],
	"./components/Filters/Sorts/Sorts.dictionary.json": [
		1043,
		3,
		173
	],
	"./components/Filters/Sorts/Sorts.module.scss": [
		1070,
		9,
		282
	],
	"./components/Filters/Sorts/index": [
		989,
		9,
		50
	],
	"./components/Filters/Sorts/index.tsx": [
		989,
		9,
		50
	],
	"./components/Filters/SportsList": [
		990,
		9,
		51
	],
	"./components/Filters/SportsList/": [
		990,
		9,
		51
	],
	"./components/Filters/SportsList/SportsList.module.scss": [
		1071,
		9,
		283
	],
	"./components/Filters/SportsList/index": [
		990,
		9,
		51
	],
	"./components/Filters/SportsList/index.tsx": [
		990,
		9,
		51
	],
	"./components/Filters/index": [
		1011,
		9,
		8,
		11,
		46
	],
	"./components/Filters/index.tsx": [
		1011,
		9,
		8,
		11,
		46
	],
	"./components/Tables": [
		992,
		9,
		71
	],
	"./components/Tables/": [
		992,
		9,
		71
	],
	"./components/Tables/Table": [
		939,
		9,
		72
	],
	"./components/Tables/Table/": [
		939,
		9,
		72
	],
	"./components/Tables/Table/Header": [
		909,
		9,
		73
	],
	"./components/Tables/Table/Header/": [
		909,
		9,
		73
	],
	"./components/Tables/Table/Header/Header.dictionary": [
		940,
		3,
		219
	],
	"./components/Tables/Table/Header/Header.dictionary.json": [
		940,
		3,
		219
	],
	"./components/Tables/Table/Header/Header.module.scss": [
		993,
		9,
		301
	],
	"./components/Tables/Table/Header/index": [
		909,
		9,
		73
	],
	"./components/Tables/Table/Header/index.tsx": [
		909,
		9,
		73
	],
	"./components/Tables/Table/Match": [
		910,
		9,
		74
	],
	"./components/Tables/Table/Match/": [
		910,
		9,
		74
	],
	"./components/Tables/Table/Match/Match.module.scss": [
		994,
		9,
		302
	],
	"./components/Tables/Table/Match/index": [
		910,
		9,
		74
	],
	"./components/Tables/Table/Match/index.tsx": [
		910,
		9,
		74
	],
	"./components/Tables/Table/Table.dictionary": [
		995,
		3,
		220
	],
	"./components/Tables/Table/Table.dictionary.json": [
		995,
		3,
		220
	],
	"./components/Tables/Table/Table.module.scss": [
		1046,
		9,
		303
	],
	"./components/Tables/Table/index": [
		939,
		9,
		72
	],
	"./components/Tables/Table/index.tsx": [
		939,
		9,
		72
	],
	"./components/Tables/Tables.dictionary": [
		1047,
		3,
		221
	],
	"./components/Tables/Tables.dictionary.json": [
		1047,
		3,
		221
	],
	"./components/Tables/Tables.module.scss": [
		1073,
		9,
		304
	],
	"./components/Tables/index": [
		992,
		9,
		71
	],
	"./components/Tables/index.tsx": [
		992,
		9,
		71
	],
	"./constants": [
		831,
		9,
		238
	],
	"./constants.ts": [
		831,
		9,
		238
	],
	"./index": [
		318,
		9
	],
	"./index.tsx": [
		318,
		9
	],
	"./reducer": [
		373,
		9
	],
	"./reducer.ts": [
		373,
		9
	],
	"./types": [
		1091,
		7,
		311
	],
	"./types.ts": [
		1091,
		7,
		312
	],
	"./utils/getScores": [
		941,
		9,
		244
	],
	"./utils/getScores.ts": [
		941,
		9,
		244
	],
	"./utils/sort": [
		991,
		9,
		245
	],
	"./utils/sort.ts": [
		991,
		9,
		245
	],
	"./utils/sportsList": [
		1044,
		9,
		246
	],
	"./utils/sportsList.ts": [
		1044,
		9,
		246
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1260;
module.exports = webpackAsyncContext;